@if (visible()) {
  <div
    class="cookie-banner"
    role="dialog"
    aria-modal="false"
    aria-label="Cookie-Einstellungen"
    aria-live="polite"
  >
    <div class="cookie-banner__body">
      <h2 class="cookie-banner__title">Datenschutz-Einstellungen</h2>
      <p class="cookie-banner__text">
        Wir nutzen Cookies. Technisch notwendige Cookies (Login, Sicherheit, Buchung) sind immer aktiv.
        Mit „Alle akzeptieren" stimmst du auch Statistik-Cookies (Google Analytics 4, Anbieter: Google
        Ireland Ltd., Datenübertragung in die USA auf Basis des EU-US Data Privacy Framework) zu. Du
        kannst deine Auswahl jederzeit im Footer unter „Cookie-Einstellungen" ändern. Mehr in der
        <a routerLink="/datenschutz">Datenschutzerklärung</a>.
      </p>

      @if (showSettings()) {
        <div class="cookie-banner__categories">
          <div class="cookie-cat">
            <div class="cookie-cat__info">
              <strong>Notwendig</strong>
              <span>Login, Sicherheit, Buchung. Immer aktiv.</span>
            </div>
            <p-toggleswitch [ngModel]="true" [disabled]="true" />
          </div>
          <div class="cookie-cat">
            <div class="cookie-cat__info">
              <strong>Statistik (Google Analytics 4)</strong>
              <span>
                Reichweitenmessung. Cookies: _ga, _ga_*, Laufzeit bis 24 Monate.
                Anbieter: Google Ireland Ltd.
              </span>
            </div>
            <p-toggleswitch [(ngModel)]="analytics" />
          </div>
        </div>
      }

      <div class="cookie-banner__actions">
        <!-- „Alle ablehnen" und „Alle akzeptieren" bewusst optisch identisch
             (gleiche Größe, Farbe, Gewicht) — gleichwertige Wahl, kein Dark
             Pattern (§ 25 TDDDG / DSGVO). „Einstellungen" ist nur ein
             Aufklapp-Trigger und darf untergeordnet wirken. -->
        <button type="button" class="cb-btn cb-btn--choice" (click)="rejectAll()">
          Alle ablehnen
        </button>
        @if (!showSettings()) {
          <button type="button" class="cb-btn cb-btn--ghost" (click)="toggleSettings()">
            Einstellungen
          </button>
        } @else {
          <button type="button" class="cb-btn cb-btn--choice" (click)="saveSelection()">
            Auswahl speichern
          </button>
        }
        <button type="button" class="cb-btn cb-btn--choice" (click)="acceptAll()">
          Alle akzeptieren
        </button>
      </div>
    </div>
  </div>
}
